import isSSR from "constants/isSSR";

/**
 * Builds a canonical tag href value.
 * @param {*} path The page path.
 */
const buildCanonicalTagHref = (path) => (
  isSSR
    ? path
    : `${window?.location?.origin}${path}`
);

export default buildCanonicalTagHref;
